/**
 * Para onde um item PODE ir a partir da etapa em que está — a regra do desenho
 * do fluxo (SPEC-20261003-1212).
 *
 * Vive num arquivo próprio porque vale em mais de um lugar: o detalhe do item e
 * o painel de resumo oferecem a mesma troca, e duas cópias divergiriam na
 * primeira regra nova. É irmã de `portas-de-entrada.ts`, que responde a outra
 * pergunta: por onde um item pode NASCER.
 */

export type NoDeFluxo = {
  flowStepId: string
  flowId: string
  flowName: string
  stepName: string
  processStepId: string
}

export type LigacaoDeFluxo = { flowId: string; from: string; to: string }

/**
 * As etapas alcançáveis a partir de `flowStepId`.
 *
 * Conta as IRMÃS: a mesma etapa de processo pode aparecer em vários fluxos, e
 * quem está nela está em todos ao mesmo tempo. Olhar só o `flowStepId` exato
 * esconderia as saídas que os outros fluxos oferecem para a mesma etapa.
 *
 * Sem etapa atual, não há "próxima": quem ainda não entrou no fluxo escolhe uma
 * PORTA DE ENTRADA, que é outra regra e outro arquivo.
 */
export function proximasEtapas(
  nos: readonly NoDeFluxo[],
  ligacoes: readonly LigacaoDeFluxo[],
  flowStepId: string | null | undefined,
): NoDeFluxo[] {
  if (!flowStepId) return []
  const atual = nos.find((n) => n.flowStepId === flowStepId)
  if (!atual) return []
  const irmas = new Set(
    nos.filter((n) => n.processStepId === atual.processStepId).map((n) => n.flowStepId),
  )
  const destinos = new Set(ligacoes.filter((l) => irmas.has(l.from)).map((l) => l.to))
  // a propria etapa nunca se oferece: trocar para onde ja se esta nao e troca
  destinos.delete(flowStepId)
  for (const irma of irmas) destinos.delete(irma)
  return nos.filter((n) => destinos.has(n.flowStepId))
}

/** Rótulo de uma etapa para a tela: o fluxo diz de qual caminho ela é. */
export const rotuloDaEtapa = (no: NoDeFluxo) => `${no.flowName} · ${no.stepName}`
